import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getTempWarehousesDeposit as getTempWarehousesDepositApi,
  addNewTempWarehouseDeposit as addNewTempWarehouseDepositApi,
  updateTempWarehouseDeposit as updateTempWarehouseDepositApi,
  deleteTempWarehouseDeposit as deleteTempWarehouseDepositApi,
  getTempWarehousesWithdraw as getTempWarehousesWithdrawApi,
  addNewTempWarehouseWithdraw as addNewTempWarehouseWithdrawApi,
  updateTempWarehouseWithdraw as updateTempWarehouseWithdrawApi,
  deleteTempWarehouseWithdraw as deleteTempWarehouseWithdrawApi,
  getTempWarehousesSummary as getTempWarehousesSummaryApi,
  addNewTempWarehouseSummary as addNewTempWarehouseSummaryApi,
  gtaRelease as gtaReleaseApi,
  gtaReleaseBulk as gtaReleaseBulkApi,
  getTempWarehousesWithdrawList as getTempWarehousesWithdrawListApi,
  getTempWarehousesDepositList as getTempWarehousesDepositListApi,
  updateReceiverLocation as updateReceiverLocationApi,
  generateTempWarehouseSummaryQRCodes as generateTempWarehouseSummaryQRCodesApi,
  getGtaLocationMap as getGtaLocationMapApi,
  deleteLocationHistory as deleteLocationHistoryApi,
} from "../../helpers/realbackend_helper";

// ===========================[ Deposit / Орлого ]===========================

export const getTempWarehousesDeposit = createAsyncThunk(
  "tempWarehouse/getTempWarehousesDeposit",
  async (filters, thunkAPI) => {
    try {
      const response = await getTempWarehousesDepositApi(filters);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response || error.message);
    }
  }
);

export const addNewTempWarehouseDeposit = createAsyncThunk(
  "tempWarehouse/addNewTempWarehouseDeposit",
  async (deposit, { rejectWithValue }) => {
    try {
      const response = await addNewTempWarehouseDepositApi(deposit);
      toast.success("ГТА Орлого амжилттай бүртгэгдлээ", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("ГТА Орлого бүртгэхэд алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error.response || error.message);
    }
  }
);

export const updateTempWarehouseDeposit = createAsyncThunk(
  "tempWarehouse/updateTempWarehouseDeposit",
  async (deposit, { rejectWithValue }) => {
    try {
      const response = await updateTempWarehouseDepositApi(deposit);
      toast.success("Мэдээллийг амжилттай засварлалаа", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Мэдээллийг засварлахад алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error.response || error.message);
    }
  }
);

export const deleteTempWarehouseDeposit = createAsyncThunk(
  "tempWarehouse/deleteTempWarehouseDeposit",
  async (id, { rejectWithValue }) => {
    try {
      await deleteTempWarehouseDepositApi(id);
      toast.success("Мэдээллийг амжилттай устгалаа", { autoClose: 3000 });
      return { id };
    } catch (error) {
      toast.error("Устгахад алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error.response || error.message);
    }
  }
);

// ===========================[ Withdraw / Зарлага ]===========================

export const getTempWarehousesWithdraw = createAsyncThunk(
  "tempWarehouse/getTempWarehousesWithdraw",
  async (filters, thunkAPI) => {
    try {
      const response = await getTempWarehousesWithdrawApi(filters);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response || error.message);
    }
  }
);

export const addNewTempWarehouseWithdraw = createAsyncThunk(
  "tempWarehouse/addNewTempWarehouseWithdraw",
  async (withdraw, { rejectWithValue }) => {
    try {
      const response = await addNewTempWarehouseWithdrawApi(withdraw);
      toast.success("ГТА Зарлага амжилттай бүртгэгдлээ", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("ГТА Зарлага бүртгэхэд алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error.response || error.message);
    }
  }
);

export const updateTempWarehouseWithdraw = createAsyncThunk(
  "tempWarehouse/updateTempWarehouseWithdraw",
  async (withdraw, { rejectWithValue }) => {
    try {
      const response = await updateTempWarehouseWithdrawApi(withdraw);
      toast.success("Мэдээллийг амжилттай засварлалаа", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Мэдээллийг засварлахад алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error.response || error.message);
    }
  }
);

export const deleteTempWarehouseWithdraw = createAsyncThunk(
  "tempWarehouse/deleteTempWarehouseWithdraw",
  async (id, { rejectWithValue }) => {
    try {
      await deleteTempWarehouseWithdrawApi(id);
      toast.success("Мэдээллийг амжилттай устгалаа", { autoClose: 3000 });
      return { id };
    } catch (error) {
      toast.error("Устгахад алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error.response || error.message);
    }
  }
);

// ===========================[ Summary / Үлдэгдэл ]===========================

export const getTempWarehousesSummary = createAsyncThunk(
  "tempWarehouse/getTempWarehousesSummary",
  async (filters, thunkAPI) => {
    try {
      const response = await getTempWarehousesSummaryApi(filters);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response || error.message);
    }
  }
);

export const addNewTempWarehouseSummary = createAsyncThunk(
  "tempWarehouse/addNewTempWarehouseSummary",
  async (summary, { rejectWithValue }) => {
    try {
      const response = await addNewTempWarehouseSummaryApi(summary);
      return response;
    } catch (error) {
      return rejectWithValue(error.response || error.message);
    }
  }
);

export const gtaRelease = createAsyncThunk(
  "tempWarehouse/gtaRelease",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await gtaReleaseApi(payload);
      toast.success("Агуулахаас амжилттай гаргалаа", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Гаргахад алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error.response || error.message);
    }
  }
);

export const gtaReleaseBulk = createAsyncThunk(
  "tempWarehouse/gtaReleaseBulk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await gtaReleaseBulkApi(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.response || error.message);
    }
  }
);

export const getTempWarehousesWithdrawList = createAsyncThunk(
  "tempWarehouse/getTempWarehousesWithdrawList",
  async (filters, thunkAPI) => {
    try {
      const response = await getTempWarehousesWithdrawListApi(filters);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response || error.message);
    }
  }
);

export const getTempWarehousesDepositList = createAsyncThunk(
  "tempWarehouse/getTempWarehousesDepositList",
  async (filters, thunkAPI) => {
    try {
      const response = await getTempWarehousesDepositListApi(filters);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response || error.message);
    }
  }
);

export const updateReceiverLocation = createAsyncThunk(
  "tempWarehouse/updateReceiverLocation",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateReceiverLocationApi(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.response || error.message);
    }
  }
);

export const deleteLocationHistory = createAsyncThunk(
  "tempWarehouse/deleteLocationHistory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteLocationHistoryApi(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.response || error.message);
    }
  }
);

export const generateTempWarehouseSummaryQRCodes = createAsyncThunk(
  "tempWarehouse/generateTempWarehouseSummaryQRCodes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await generateTempWarehouseSummaryQRCodesApi();
      return response;
    } catch (error) {
      return rejectWithValue(error.response || error.message);
    }
  }
);

export const getGtaLocationMap = createAsyncThunk(
  "tempWarehouse/getGtaLocationMap",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getGtaLocationMapApi();
      return response;
    } catch (error) {
      return rejectWithValue(error.response || error.message);
    }
  }
);
